<div class="appdiv subtool">
  <div class="header-main">
    <button class="back_icon me-2" (click)="goBack()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
    <div class="page_header">
      <h5 class="page_header_title" translate>Blogs List</h5>
    </div>
  </div>

  <div class="header-actions">
    <div class="search-wrapper">
      <i class="search-icon fas fa-search">search</i>
      <input
        type="text"
        placeholder="Search blogs..."
        [(ngModel)]="searchText"
        class="search-input"
        (input)="searchfilter()"
      />
    </div>

    <button mat-flat-button color="primary" (click)="openDialog('ADD')">
      <i class="fa-solid fa-plus"></i>
      <span translate>Add Blog</span>
    </button>
  </div>
</div>
<app-toast></app-toast>

<div class="frame">
  <div class="table-container">
    <table mat-table [dataSource]="bloglist" class="mat-elevation-z4">
      <!-- Sl. No. -->
      <ng-container matColumnDef="sl.no">
        <th mat-header-cell *matHeaderCellDef translate>Sl. No.</th>
        <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
      </ng-container>

      <!-- Title -->
      <ng-container matColumnDef="Title">
        <th mat-header-cell *matHeaderCellDef translate>Title</th>
        <td mat-cell *matCellDef="let element">{{ element.title }}</td>
      </ng-container>

      <!-- Attachments -->
      <ng-container matColumnDef="images">
        <th mat-header-cell *matHeaderCellDef translate>Attachments</th>
        <td mat-cell *matCellDef="let element">
          <img
            *ngIf="element.image_url"
            [src]="base_url + containerName + '/' + element.image_url"
            alt="Banner"
            class="banner-image"
          />
          <span *ngIf="!element.image_url" class="text-muted">—</span>
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef translate>Status</th>
        <td mat-cell *matCellDef="let element">
          <p
            [ngClass]="{
              'status-active': element.status === 'ACTIVE',
              'status-inactive': element.status !== 'ACTIVE',
            }"
          >
            <b>{{ element.status }}</b>
          </p>
        </td>
      </ng-container>

      <!-- Publish -->
      <ng-container matColumnDef="publish">
        <th mat-header-cell *matHeaderCellDef translate>Publish</th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            color="primary"
            [checked]="element.is_published === 1"
            (change)="publicChange($event, element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef translate>Actions</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center gap-2">
            <button
              mat-stroked-button
              color="primary"
              (click)="Viewblog(element.id, 'VIEW')"
              translate
            >
              View
            </button>

            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="More actions"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>

            <mat-menu #menu="matMenu" xPosition="before">
              <button mat-menu-item (click)="editblog(element.id, 'EDIT')">
                <mat-icon>edit</mat-icon>
                <span translate>Edit</span>
              </button>
              <button
                mat-menu-item
                class="text-danger"
                (click)="deleteblog(element.id)"
              >
                <i class="fa-solid fa-trash"></i>
                <span translate>Delete</span>
              </button>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>

<div class="pagination mt-3" *ngIf="total_count > 5">
  <app-pagination
    style="width: 100%; max-width: 480px"
    [datafromparent]="total_count"
    (onDatePicked)="pagination($event)"
  ></app-pagination>
</div>
